import { render, staticRenderFns } from "./SaveReportSettingsCard.vue?vue&type=template&id=e1e8c9e2"
import script from "./SaveReportSettingsCard.vue?vue&type=script&lang=ts"
export * from "./SaveReportSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports